import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '75%',
    '@media (max-width: 900px)': {
      width: '95%',
      flexDirection: 'column',
      justifyContent: 'initial',
      alignItems: 'initial',
      pading: '1rem',
      boxShadow: 'none',
    },
  },
  formControl: {
    fontFamily: theme.typography.fontFamily,
    marginBottom: '1rem',
    width: '14%',
    '@media (max-width: 900px)': {
      width: '100%',
    },
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.lightPrimary.main,
    fontSize: '42px',
    fontWeight: '400',
  },
  sortButtons: {
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '70%',
    flexWrap: 'wrap',
    marginTop: '1rem',
    '@media (max-width: 900px)': {
      width: '95%',
      fontWeight: 200,
    },
  },
  availabilityContainer: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    '@media (max-width: 900px)': {
      marginTop: '1rem',
      justifyContent: 'start',
    },
  },
  typeAvailability: {
    margin: '0 0.5rem 0 0.5rem',
    fontWeight: 300,
    fontSize: '15px',
  },
  doctorAppointments: {
    backgroundColor: '#f1f1f1',
    fontFamily: theme.typography.fontFamily,
    width: '100%',
    padding: '30px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    border: `solid 2px ${theme.palette.lightPrimary.main}`,
    marginRight: '1rem',
    width: '5rem',
    height: '5rem',
  },
  textContainer: {
    marginRight: 'auto',
    marginLeft: '30px',
    fontFamily: 'roboto',
  },
  gridContainer: {
    paddingBottom: '16px',
    width: '180px',
    position: 'fixed',
    zIndex: '1',
    top: '98px',
    right: '5px',
    backgroundColor: 'white',
    overflowX: 'hidden',
    transition: '1s',
    boxShadow: theme.shadows[5],
  },
  openCardContainerWidth: {
    width: '180px',
    right: '5px',
  },
  closedCardContainerWidth: {
    width: '0',
    right: '0',
  },
  guardSwitch: {
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        color: '#00c0ff',
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.25,
        },
        '& + .MuiSwitch-track': {
          backgroundColor: '#78e0ff',
          opacity: 1,
        },
      },
      color: '#757575',
    },
    '& .MuiSwitch-track': {
      backgroundColor: '#9E9E9E',
      opacity: 1,
    },
  },
  guardCardItemContainer: {
    width: '160px',
    height: '40px',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
  },
  guardCardItemText: {
    padding: '0 0 0 12px',
    fontSize: '11px',
  },
  iconContainer: {
    height: '34px',
    width: '34px',
    alignContent: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    display: 'flex',
    flexWrap: 'wrap',

    position: 'fixed',
    zIndex: '1',
    top: '100px',
    right: '5px',
    backgroundColor: '#067fcf',
    overflowX: 'hidden',
    transition: '1s',
    borderRadius: '3px',
  },
  openCardIconPosition: {
    right: '190px',
  },
  closedCardIconPosition: {
    right: '5px',
  },
  icon: {
    color: 'white',
    height: '24px',
    width: '24x',
    justifyContent: 'center',
  },
}));
